import React from 'react'
import Layout from '../components/layout'


const AdvertiserDiscount = () => {

    const advertiserDiscountForm = `<!-- Note :
    - You can modify the font style and form style to suit your website. 
    - Code lines with comments Do not remove this code are required for the form to work properly, make sure that you do not remove these lines of code. 
    - The Mandatory check script can modified as to suit your business needs. 
    - It is important that you test the modified form before going live.-->
 <div id='crmWebToEntityForm' class='zcwf_lblLeft crmWebToEntityForm'>
     <meta name='viewport' content='width=device-width, initial-scale=1.0'>
     <META HTTP-EQUIV='content-type' CONTENT='text/html;charset=UTF-8'>
     <form action='https://crm.zoho.com/crm/WebToLeadForm' name=WebToLeads2766946000005818001 method='POST'
         onSubmit='javascript:document.charset="UTF-8"; return checkMandatory2766946000005818001()'
         accept-charset='UTF-8'>
         <input type='text' style='display:none;' name='xnQsjsdp'
             value='91969da047839e04c11caeed617c62ef24865ebe63b80fb1d6284f1dd299d113'></input>
         <input type='hidden' name='zc_gad' id='zc_gad' value=''></input>
         <input type='text' style='display:none;' name='xmIwtLD'
             value='88c267bf398dce3a54849af3d0746b437ad302306431a1f589505d431d5ed99e'></input>
         <input type='text' style='display:none;' name='actionType' value='TGVhZHM='></input>
         <input type='text' style='display:none;' name='returnURL'
             value='https&#x3a;&#x2f;&#x2f;dochaseadx.com&#x2f;success'> </input>
         <!-- Do not remove this code. -->
         <style>
             html,
             body {
                 margin: 0px;
             }
 
             #crmWebToEntityForm.zcwf_lblLeft {
                 width: 100%;
                 padding: 25px;
                 margin: 0 auto;
                 box-sizing: border-box;
             }
 
             #crmWebToEntityForm.zcwf_lblLeft * {
                 box-sizing: border-box;
             }
 
             #crmWebToEntityForm {
                 text-align: left;
             }
 
             #crmWebToEntityForm * {
                 direction: ltr;
             }
 
             .zcwf_lblLeft .zcwf_title {
                 word-wrap: break-word;
                 padding: 0px 6px 10px;
                 font-weight: bold
             }
 
             .zcwf_lblLeft.cpT_primaryBtn:hover {
                 background: linear-gradient(#02acff 0, #006be4 100%) no-repeat padding-box !important;
                 box-shadow: 0 -2px 0 0 #0159b9 inset !important;
                 border: 0 !important;
                 color: #fff !important;
                 outline: 0 !important;
             }
 
             .zcwf_lblLeft .zcwf_col_fld input[type=text],
             input[type=password],
             .zcwf_lblLeft .zcwf_col_fld textarea {
                 width: 100%;
                 border: 1px solid #c0c6cc !important;
                 resize: vertical;
                 border-radius: 2px;
                 float: left;
             }
 
             .zcwf_lblLeft .zcwf_col_lab {
                 width: 100%;
                 word-break: break-word;
                 padding: 0px 6px 0px;
                 margin-right: 10px;
                 margin-top: 5px;
                 float: left;
                 min-height: 1px;
             }
 
             .zcwf_lblLeft .zcwf_col_fld {
                 float: left;
                 width: 100%;
                 padding: 0px 6px 0px;
                 position: relative;
                 margin-top: 5px;
             }
 
             .zcwf_lblLeft .zcwf_privacy {
                 padding: 6px;
             }
 
             .zcwf_lblLeft .wfrm_fld_dpNn {
                 display: none;
             }
 
             .dIB {
                 display: inline-block;
             }
 
             .zcwf_lblLeft .zcwf_col_fld_slt {
                 width: 100%;
                 border: 1px solid #ccc;
                 background: #fff;
                 border-radius: 4px;
                 font-size: 12px;
                 float: left;
                 resize: vertical;
                 padding: 2px 5px;
             }
 
             .zcwf_lblLeft .zcwf_row:after,
             .zcwf_lblLeft .zcwf_col_fld:after {
                 content: '';
                 display: table;
                 clear: both;
             }
 
             .zcwf_lblLeft .zcwf_col_help {
                 float: left;
                 margin-left: 7px;
                 font-size: 12px;
                 max-width: 35%;
                 word-break: break-word;
             }
 
             .zcwf_lblLeft .zcwf_help_icon {
                 cursor: pointer;
                 width: 16px;
                 height: 16px;
                 display: inline-block;
                 background: #fff;
                 border: 1px solid #c0c6cc;
                 color: #c1c1c1;
                 text-align: center;
                 font-size: 11px;
                 line-height: 16px;
                 font-weight: bold;
                 border-radius: 50%;
             }
 
             .zcwf_lblLeft .zcwf_row {
                 margin: 15px 0px;
             }
 
             .zcwf_lblLeft .formsubmit {
                 margin-right: 5px;
                 cursor: pointer;
             }
 
             .zcwf_lblLeft .zcwf_privacy_txt {
                 width: 90%;
                 color: rgb(0, 0, 0);
                 font-size: 12px;
                 display: inline-block;
                 vertical-align: top;
                 color: var(--baseColor);
                 padding-top: 2px;
                 margin-left: 6px;
             }
 
             .zcwf_lblLeft .zcwf_button {
                 border: 1px solid #c0c6cc;
                 cursor: pointer;
                 overflow: hidden;
                 text-overflow: ellipsis;
                 white-space: nowrap;
             }
 
             .zcwf_lblLeft .zcwf_tooltip_over {
                 position: relative;
             }
 
             .zcwf_lblLeft .zcwf_tooltip_ctn {
                 position: absolute;
                 background: #dedede;
                 padding: 3px 6px;
                 top: 3px;
                 border-radius: 4px;
                 word-break: break-word;
                 min-width: 100px;
                 max-width: 150px;
                 color: var(--baseColor);
                 z-index: 100;
             }
 
             .zcwf_lblLeft .zcwf_ckbox {
                 float: left;
             }
 
             .zcwf_lblLeft .zcwf_file {
                 width: 55%;
                 box-sizing: border-box;
                 float: left;
             }
 
             .clearB:after {
                 content: '';
                 display: block;
                 clear: both;
             }
 
             @media all and (max-width: 600px) {
 
                 .zcwf_lblLeft .zcwf_col_lab,
                 .zcwf_lblLeft .zcwf_col_fld {
                     width: auto;
                     float: none !important;
                 }
 
                 .zcwf_lblLeft .zcwf_col_help {
                     width: 40%;
                 }
             }
 
             .form-container {
                 display: flex;
                 flex-direction: column;
             }
 
             label {
                 font-size: 14px;
                 font-weight: 500;
             }
 
             input {
                 background-color: rgba(172, 172, 172, 0.3);
                 border-radius: 0.375rem;
                 padding: 0.375rem;
                 color: black
             }
 
             .zcwf_button {
                 background-color: #F92539;
                 color: white;
                 padding-top: 0.75rem;
                 padding-bottom: 0.75rem;
                 padding-left: 2.75rem;
                 padding-right: 2.75rem;
                 border-radius: 0.375rem;
                 font-weight: 700;
                 font-size: 0.875rem;
                 margin-top: 24px;
                 display: flex;
                 justify-content: center;
                 opacity: 100;
                 width: 100%;
 
                 @media screen and (max-width: 1024px) {
                     font-size: 0.75rem;
                 }
             }
         </style>
 
         <!-- <div class='zcwf_title' style='max-width: 600px;color: black; font-family:Arial;'>Discount Leads</div> -->
         <div class="form-container">
             <div class='zcwf_col_lab' style='font-size:12px;'><label for='First_Name'>First
                     Name<span style='color:red;'>*</span></label></div>
             <div class='zcwf_col_fld'><input type='text' id='First_Name' name='First Name' maxlength='40'></input>
                 <div class='zcwf_col_help'></div>
             </div>
             <div class='zcwf_col_lab' style='font-size:12px;'><label for='Last_Name'>Last
                     Name<span style='color:red;'>*</span></label></div>
             <div class='zcwf_col_fld'><input type='text' id='Last_Name' name='Last Name' maxlength='80'></input>
                 <div class='zcwf_col_help'></div>
             </div>
             <div class='zcwf_col_lab' style='font-size:12px;'><label for='Email'>Email<span
                         style='color:red;'>*</span></label></div>
             <div class='zcwf_col_fld'><input type='text' ftype='email' autocomplete='false' id='Email' name='Email'
                     maxlength='100'></input>
                 <div class='zcwf_col_help'></div>
             </div>
             <div class='zcwf_col_lab' style='font-size:12px;'><label for='Company'>Company<span
                         style='color:red;'>*</span></label></div>
             <div class='zcwf_col_fld'><input type='text' id='Company' name='Company' maxlength='200'></input>
                 <div class='zcwf_col_help'></div>
             </div>
             <div class='zcwf_col_lab' style='font-size:12px;'><label for='Phone'>Phone<span
                         style='color:red;'>*</span></label></div>
             <div class='zcwf_col_fld'><input type='text' id='Phone' name='Phone' maxlength='30'></input>
                 <div class='zcwf_col_help'></div>
             </div>
             <div class='zcwf_col_lab' style='font-size:12px;'><label for='Industry'>Which solution
                     are you interested in<span style='color:red;'>*</span></label></div>
             <div class='zcwf_col_fld'><select class='zcwf_col_fld_slt' id='Industry' name='Industry'>
                     <option value='-None-'>-None-</option>
                     <option value='Programmatic&#x20;Advertising'>Programmatic
                         &#x20;Advertising
                     </option>
                     <option value='Lead&#x20;Generation'>Lead Generation</option>
                     <option value='App&#x20;Installations'>App Installations</option>
                     <option value='Lead&#x20;Generation'>Lead Generation</option>
                     <option value='Website&#x20;Traffic'>Website Traffic</option>
                     <option value='Sign&#x20;Up'>Sign Up</option>
                     <option value='Registration'>Registration</option>
                     <option value='Customer&#x20;Engagement'>Customer Engagement</option>
                     <option value='Retargeting'>Retargeting</option>
                 </select>
                 <div class='zcwf_col_help'></div>
             </div>
             <div class='zcwf_col_lab'></div>
             <div class='zcwf_col_fld'><input type='submit' id='formsubmit' class='formsubmit zcwf_button' value='Submit'
                     title='Submit'>
             </div>
         </div>
 
         <script>
             function validateEmail2766946000005818001() {
                 var form = document.forms['WebToLeads2766946000005818001'];
                 var emailFld = form.querySelectorAll('[ftype=email]');
                 var i;
                 for (i = 0; i < emailFld.length; i++) {
                     var emailVal = emailFld[i].value;
                     if ((emailVal.replace(/^\s+|\s+$/g, '')).length != 0) {
                         var atpos = emailVal.indexOf('@');
                         var dotpos = emailVal.lastIndexOf('.');
                         if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
                             alert('Please enter a valid email address. ');
                             emailFld[i].focus();
                             return false;
                         }
                     }
                 }
                 return true;
             }
 
             function checkMandatory2766946000005818001() {
                 var mndFileds = new Array('Company', 'First Name', 'Last Name', 'Email', 'Phone', 'Industry');
                 var fldLangVal = new Array('Company', 'First\x20Name', 'Last\x20Name', 'Email', 'Phone', 'Industry');
                 for (i = 0; i < mndFileds.length; i++) {
                     var fieldObj = document.forms['WebToLeads2766946000005818001'][mndFileds[i]];
                     if (fieldObj) {
                         if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length == 0) {
                             if (fieldObj.type == 'file') {
                                 alert('Please select a file to upload.');
                                 fieldObj.focus();
                                 return false;
                             }
                             alert(fldLangVal[i] + ' cannot be empty.');
                             fieldObj.focus();
                             return false;
                         } else if (fieldObj.nodeName == 'SELECT') {
                             if (fieldObj.options[fieldObj.selectedIndex].value == '-None-') {
                                 alert(fldLangVal[i] + ' cannot be none.');
                                 fieldObj.focus();
                                 return false;
                             }
                         } else if (fieldObj.type == 'checkbox') {
                             if (fieldObj.checked == false) {
                                 alert('Please accept  ' + fldLangVal[i]);
                                 fieldObj.focus();
                                 return false;
                             }
                         }
                         try {
                             if (fieldObj.name == 'Last Name') {
                                 name = fieldObj.value;
                             }
                         } catch (e) { }
                     }
                 }
                 if (!validateEmail2766946000005818001()) { return false; }
                 document.querySelector('.crmWebToEntityForm .formsubmit').setAttribute('disabled', true);
             }
 
             function tooltipShow2766946000005818001(el) {
                 var tooltip = el.nextElementSibling;
                 var tooltipDisplay = tooltip.style.display;
                 if (tooltipDisplay == 'none') {
                     var allTooltip = document.getElementsByClassName('zcwf_tooltip_over');
                     for (i = 0; i < allTooltip.length; i++) {
                         allTooltip[i].style.display = 'none';
                     }
                     tooltip.style.display = 'block';
                 } else {
                     tooltip.style.display = 'none';
                 }
             }
         </script>
         <!-- Do not remove this --- Analytics Tracking code starts -->
         <script id='wf_anal'
             src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=88c267bf398dce3a54849af3d0746b437ad302306431a1f589505d431d5ed99egid91969da047839e04c11caeed617c62ef24865ebe63b80fb1d6284f1dd299d113gid885e3c1045bd9bdcc91bdf30f82b5696gid14f4ec16431e0686150daa43f3210513&tw=61690b96c1d0471b638f31426f38e68aa67fb7ed6da86f32dc10ad817fe55a0a'></script>
         <!-- Do not remove this --- Analytics Tracking code ends. -->
     </form>
 </div>`

    return (
        <Layout>
            {
                <section className='py-20 lg:py-44 lg:max-w-[1440px] mx-auto px-6 text-[#4F4F4F]'>
                    <div className='mx-8'>
                        <div className='lg:flex lg:space-x-10 space-y-4 lg:space-y-0 mt-2'>
                            <div className='xl:-mt-8'>
                                <p className='text-3xl lg:text-4xl xl:text-6xl font-bold lg:leading-[50px] xl:leading-[80px]'>Enjoy a whopping <span className='text-[#00C28B]'>10X Return</span> on Ad spend!</p>
                                <p className='mt-5 lg:mt-10 text-xl lg:text-3xl font-medium'> Get up to <span className='text-brand-red'>10% discount</span> on all our digital solutions from now till the <span className='text-brand-red'>15th of October 2023.</span></p>
                                <p className='mt-5 lg:mt-10 text-xl lg:text-2xl font-bold'>Fill the form to get access to the discount now!</p>
                            </div>
                            <div className='bg-gradient-to-b from-[#3DBA88] to-[#F02135] p-3 lg:p-7 rounded-2xl lg:rounded-[35px] w-full'>
                                <div className='bg-white rounded-r-2xl lg:rounded-r-[35px] h-full ' dangerouslySetInnerHTML={{ __html: advertiserDiscountForm }} >

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }
        </Layout>
    )
}


export default AdvertiserDiscount;